const activityLogKeys = {
    getActivityLogs: (target_model: string, target_id: string) => [
        'activity_logs',
        target_model,
        target_id,
    ],
};

export default activityLogKeys;
